import { FileText, Link, Video } from "lucide-react";

const ICONS = {
	doc: FileText,
	link: Link,
	video: Video,
} as const;

type BadgeColor = "research" | "article" | "video" | "plan";

const BADGE_BG: Record<BadgeColor, string> = {
	research: "bg-cv-badge-research",
	article: "bg-cv-badge-article",
	video: "bg-cv-badge-video",
	plan: "bg-cv-badge-plan",
};

const BADGE_TEXT: Record<BadgeColor, string> = {
	research: "text-cv-text-research",
	article: "text-cv-text-article",
	video: "text-cv-text-video",
	plan: "text-cv-text-plan",
};

export function LibraryItem({
	icon,
	title,
	summary,
	badge,
	badgeColor,
	date,
	processing,
}: {
	icon: "doc" | "link" | "video";
	title: string;
	summary: string;
	badge: string;
	badgeColor: BadgeColor;
	date: string;
	processing?: boolean;
}) {
	const Icon = ICONS[icon];
	return (
		<div
			className={`flex items-start gap-3 border-b px-6 py-3.5 ${
				processing
					? "border-cv-accent-border bg-cv-accent-glow"
					: "border-cv-bdr"
			}`}
		>
			<Icon
				className={`mt-0.5 h-4 w-4 shrink-0 ${processing ? "text-cv-accent" : "text-cv-fg-muted"}`}
				strokeWidth={1.5}
			/>
			<div className="min-w-0 flex-1">
				<div className="text-cv-fg text-[13px] font-medium">
					{title}
				</div>
				<div className="text-cv-fg-muted truncate text-[11px]">
					{summary}
				</div>
			</div>
			<span
				className={`shrink-0 rounded px-1.5 py-0.5 text-[9px] font-semibold tracking-wide uppercase ${BADGE_BG[badgeColor]} ${BADGE_TEXT[badgeColor]}`}
			>
				{badge}
			</span>
			<span
				className={`shrink-0 text-[10px] ${processing ? "text-cv-accent" : "text-cv-fg-muted"}`}
			>
				{processing ? "Processing" : date}
			</span>
		</div>
	);
}
